import Character from "../domain/model/character";

export type UnionsMap = Map<string, Character[]>;
export type UnionSortOrder = "nameAsc" | "nameDesc" | "groupAsc" | "groupDesc";

export function parseCharacterNames(input: string): string[] {
  return Array.from(new Set(
      input
          .split(/[\s,]+/)
          .map(name => name.trim())
          .filter(Boolean)
  ));
}

export function findUnionGroupsByCharacterNames(doneMembersMap: UnionsMap, input: string): UnionsMap {
  const characterNames = new Set(parseCharacterNames(input));

  if (!characterNames.size) {
    return new Map();
  }

  return new Map(
      Array.from(doneMembersMap)
          .filter(([, characters]) => characters.some(character => characterNames.has(character.name)))
  );
}

export function flattenUnionNames(unionsMap: UnionsMap): string[] {
  return Array.from(unionsMap.values()).flat().map(character => character.name);
}

export function sortUnionNames(unionsMap: UnionsMap, sortOrder: UnionSortOrder): string[] {
  const groups = Array.from(unionsMap.values());

  if (sortOrder === "nameAsc" || sortOrder === "nameDesc") {
    const names = groups.flat().map(character => character.name)
        .sort((a, b) => a.localeCompare(b, "ko"));
    return sortOrder === "nameAsc" ? names : names.reverse();
  }

  const names = groups.flat().map(character => character.name);
  return sortOrder === "groupAsc" ? names : names.reverse();
}

export function findMissingCharacterNames(doneMembersMap: UnionsMap, input: string): string[] {
  const allDoneNames = new Set(flattenUnionNames(doneMembersMap));
  return parseCharacterNames(input).filter(name => !allDoneNames.has(name));
}
